/**
 * Klassifiziert beliebige (unbekannte) Fehlerobjekte anhand ihres HTTP-Status.
 *
 * Der Response-Error-Interceptor (`src/editor/services/http.ts`) reicht 403/404
 * als AxiosError durch, d.h. `error.response.status` ist im Fehler vorhanden.
 * Kein axios-Import nötig — defensive Navigation reicht.
 */

/**
 * Liest den HTTP-Status aus einem Fehlerobjekt, sofern vorhanden.
 */
function statusOf(err: unknown): number | undefined {
  if (typeof err === 'object' && err !== null && 'response' in err) {
    const resp = (err as { response?: { status?: number } }).response
    return resp?.status
  }
  return undefined
}

/**
 * True, wenn der Fehler einen HTTP-403-Status (Forbidden) trägt.
 */
export function isForbidden(err: unknown): boolean {
  return statusOf(err) === 403
}

/**
 * True, wenn der Fehler einen HTTP-404-Status (Not Found) trägt.
 */
export function isNotFound(err: unknown): boolean {
  return statusOf(err) === 404
}
